import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'empty-layout',
    templateUrl: './empty.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [FuseLoadingBarComponent, RouterOutlet],
    host: {
        '[class.embed-dialog-scroll]': 'embedDialogScroll',
    },
    styles: [
        `
            empty-layout {
                display: block;
                width: 100%;
                min-height: 100%;
            }

            empty-layout.embed-dialog-scroll {
                display: block;
                width: 100%;
                height: auto;
                overflow: visible;
            }
        `,
    ],
})
export class EmptyLayoutComponent implements OnInit, OnDestroy {
    private readonly _route = inject(ActivatedRoute);
    private readonly _unsubscribeAll = new Subject<void>();

    /** True when opened inside the document-detail embed dialog iframe. */
    embedDialogScroll = false;

    ngOnInit(): void {
        const apply = (): void => {
            let route = this._route;
            while (route.firstChild) {
                route = route.firstChild;
            }
            const fromLeaf = route.snapshot.queryParamMap.get('embedDialog') === '1';
            const fromRoot = this._route.snapshot.queryParamMap.get('embedDialog') === '1';
            const fromUrl = new URLSearchParams(window.location.search).get('embedDialog') === '1';
            this.embedDialogScroll = fromLeaf || fromRoot || fromUrl;

            document.documentElement.classList.toggle('embed-dialog-frame', this.embedDialogScroll);
            document.body.classList.toggle('embed-dialog-frame', this.embedDialogScroll);
        };

        apply();
        this._route.queryParamMap.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => apply());
    }

    ngOnDestroy(): void {
        document.documentElement.classList.remove('embed-dialog-frame');
        document.body.classList.remove('embed-dialog-frame');
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
